import React from "react";
import Testimonials from "../home/Testimonials";

const KeyFeaturesTestimonials = () => {
  return <Testimonials />;
};

export default KeyFeaturesTestimonials;
